import React, { useState } from "react";
import "./Header.css";
import Popup from "reactjs-popup";
import Cookies from "js-cookie";
import axios from "axios";
import "reactjs-popup/dist/index.css";
import { useHistory } from "react-router-dom";
import {
  getSuperMatchMaker,
  getDoubleCounsler,
  getVip,
  getFirstName,
  getGender,
  getSignedIn,
  getExpiredVip,
  getStarCount,
  // getFriendlyTag,
} from "../../handlers/dictionaryHandler";
import DateCount from "./DateCount";

const Header = () => {
  let history = useHistory();

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };
  const [starExplain, setStarExplain] = useState(false);
  const [vipExplain, setVipExplain] = useState(false);
  const [bellOpen, setBellOpen] = useState(false);
  const [otherGiveResponse, setOtherGiveResponse] = useState(0);

  const [cntNoti, setCntNoti] = useState(2);

  const humburgerClicked = () => {
    if (document.getElementById("slidepanel1").style.width === "200px") {
      document.getElementById("slidepanel1").style.width = "0px";
    } else {
      document.getElementById("slidepanel1").style.width = "200px";
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/getNoti",
        {},
        config,
      );
      const userData = response.data;
      if (userData[0].length > 0) {
        setOtherGiveResponse(userData[0][0].otherGiveResponse);
      }
    } catch (error) {}
  };

  const bellClick = async () => {
    setBellOpen(true);
    await fetchData();
  };

  const aboutDoubleClicked = () => {
    history.push("/aboutdouble");
  };

  const contactUsClicked = () => {
    history.push("/contactus");
  };

  const tellAboutUsClicked = () => {
    history.push("/tellaboutus");
  };

  const qaClicked = () => {
    history.push("/qa");
  };

  const subscribeClicked = () => {
    history.push("/subscribe");
  };

  const myProfileClicked = () => {
    history.push("/myprofile");
  };

  const chngPwdClicked = () => {
    history.push("/changepassword");
  };

  const almostClicked = () => {
    history.push("/almost");
  };

  const homePageClicked = () => {
    humburgerClicked();
    history.push("/Questionnaires");
  };

  const collectStarsClicked = () => {
    history.push("/collectstars");
  };

  const blogClicked = () => {
    history.push("/blog");
  };

  const passkeyClicked = () => {
    localStorage.setItem("passkeyOfferClosed", "0");
    document.getElementById("slidepanel1").style.width = "0px";
    window.dispatchEvent(new Event("openPasskeyOffer"));
    history.push("/Questionnaires");
  };

  const exitClicked = () => {
    Cookies.remove("userId");
    localStorage.setItem("newUser", 0);
    history.push("/");
  };

  const superMatchMakerClicked = () => {
    history.push("/supermatchmaker");
  };

  return (
    <div className="header">
      <div
        className={getVip() === "0" ? "lbl_grey" : "invisible gap"}
        onClick={() => setVipExplain(true)}
      >
        <u>למה כדאי להיות מנוי?</u>
      </div>

      <Popup
        open={vipExplain}
        contentStyle={{ minWidth: "35%", maxWidth: "45%", borderRadius: "5px" }}
        position="top center"
        onClose={() => setVipExplain(false)}
        closeOnDocumentClick
        closeOnEscape
      >
        <div
          className="exit-popup"
          onClick={() => {
            setVipExplain(false);
          }}
        >
          x
        </div>
        <div
          style={{
            textAlign: "center",
            marginBottom: "-15px",
            fontSize: "medium",
          }}
        >
          <b>למנויים יש יותר דייטים!</b>
        </div>
        <br /> <br />
        <DateCount />
        <br />
      </Popup>

      <div className={getVip() === "0" ? "invisible gap" : "lbl_grey"}>
        מנוי עד: {getExpiredVip()}
      </div>
      {/* <div
        className={getFriendlyTag() === "1" ? "friendlytag" : "invisible"}
      ></div> */}

      <div className="bell" onClick={() => bellClick()}>
        <div
          style={{
            lineHeight: "52px",
            margin: "0 auto",
          }}
        >
          <div className="redCircle">{"•"}</div>
        </div>
      </div>
      <div className="starTag" onClick={() => setStarExplain(true)}>
        <div
          style={{
            lineHeight: "52px",
            margin: "0 auto",
            textAlign: "center",
            fontSize: "10px",
            color: "white",
          }}
          className="lbl_grey"
        >
          {" "}
          {getStarCount()}{" "}
        </div>
      </div>

      <Popup
        open={starExplain}
        contentStyle={{ minWidth: "30%", maxWidth: "40%", borderRadius: "5px" }}
        position="top center"
        onClose={() => setStarExplain(false)}
        closeOnDocumentClick
        closeOnEscape
      >
        <div
          className="exit-popup"
          onClick={() => {
            setStarExplain(false);
          }}
        >
          x
        </div>
        הי! יש לך {getStarCount()} נקודות!!
      </Popup>

      <Popup
        open={bellOpen}
        contentStyle={{
          minWidth: "30%",
          maxWidth: "40%",
          borderRadius: "5px",
          top: "-80px",
        }}
        position="top center"
        onClose={() => setBellOpen(false)}
        closeOnDocumentClick
        closeOnEscape
      >
        <div
          className="exit-popup"
          onClick={() => {
            setBellOpen(false);
          }}
        >
          x
        </div>
        <br />
        <br />
        {otherGiveResponse > 0 ? (
          <div className="bellNote">
            <b>קיבלת תשובה על ההתאמה מהצד השני :)</b>
          </div>
        ) : (
          <></>
        )}
        {localStorage.getItem("cntMatches") > 0 ? (
          <div>
            <div className="bellNote"> הי קיבלת התאמה חדשה!</div>

            <div className="bellNote">
              {" "}
              חדש! מקבלים התראה על התאמה
              <b> בהודעת סמס! </b>
              אם לא קיבלת, אז מבצעים חיפוש בטלפון בהודעות: double2love, ומסמנים:
              "לא ספאם"
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className="bellNote">
          {" "}
          {/* <a
            href="https://paypage.takbull.co.il/1PfzH"
            target="_blank"
            rel="noopener noreferrer"
          >
            קישור
          </a> */}
        </div>
        <div className="bellNote">
          {" "}
          בקרוב יוצגו כאן הודעות נוספות. יש לך רעיון להתראה מסוימת? אפשר לכתוב
          לנו
          <br />
          <a
            href={"https://wa.me/972549624084"}
            target="_blank"
            rel="noopener noreferrer"
          >
            כאן
          </a>
        </div>
      </Popup>

      {/* <div
        className={getSignedIn() === "1" ? (getVip() === "0" ? "" : "vip") : ""}
      ></div> */}
      {/* <div className="space"></div> */}
      <div className="lbl_grey"> היי {getFirstName()}</div>

      <div
        className={
          getSignedIn() === "1"
            ? getGender() === "1"
              ? "aboutmeiconw"
              : "aboutmeiconm"
            : ""
        }
        onClick={myProfileClicked}
      ></div>

      <div id="slidepanel1">
        <div className="slidepanel-close" onClick={humburgerClicked}>
          X
        </div>

        {/* <div className="button-slidepanel" onClick={aboutDoubleClicked}>
          אודות
        </div> */}

        <div className="slidepanel-category">החשבון שלי</div>
        <div className="button-slidepanel" onClick={myProfileClicked}>
          הפרופיל שלי
        </div>
        <div className="button-slidepanel" onClick={chngPwdClicked}>
          שינוי סיסמה
        </div>
        <div className="button-slidepanel" onClick={passkeyClicked}>
          כניסה מהירה למערכת
        </div>
        <div className="button-slidepanel" onClick={almostClicked}>
          כמעט מתאים
        </div>

        <div className="slidepanel-category">תוספות</div>

        <div className="button-slidepanel" onClick={blogClicked}>
          בלוג
        </div>
        <div className="button-slidepanel" onClick={subscribeClicked}>
          רכישת מנוי
        </div>
        <div className="button-slidepanel" onClick={collectStarsClicked}>
          צבירת נקודות
        </div>
        <div className="slidepanel-category">עזרה ויצירת קשר</div>
        <div className="button-slidepanel" onClick={qaClicked}>
          שאלות ותשובות
        </div>
        <div className="button-slidepanel" onClick={tellAboutUsClicked}>
          הודעות שקיבלנו
        </div>

        <div className="button-slidepanel" onClick={contactUsClicked}>
          יצירת קשר
        </div>

        <div className="slidepanel-category">כללי</div>

        <div className="button-slidepanel" onClick={exitClicked}>
          יציאה מהמערכת
        </div>

        <div
          className={
            getDoubleCounsler() === "0" ? " invisible" : " button-slidepanel"
          }
          onClick={superMatchMakerClicked}
        >
          {getSuperMatchMaker() === "1" ? " כניסת מנהל" : " דאבל הלפ"}
        </div>
      </div>
      {/* <div
        className="info-double-date"
        onClick={() => setIsAboutDisplayed(true)}
      ></div>
      <Popup
        open={isAboutDisplayed}
        contentStyle={{ minWidth: "30%", maxWidth: "60%", borderRadius: "5px" }}
        position="right center"
        onClose={() => setIsAboutDisplayed(false)}
        closeOnDocumentClick
        closeOnEscape
      >
        {AboutHelper}
      </Popup> */}
      {/* <div className="help" onClick={() => setIsHelpDisplayed(true)}></div>
      <Popup
        open={isHelpDisplayed}
        contentStyle={{ minWidth: "30%", maxWidth: "60%", borderRadius: "5px" }}
        position="right center"
        onClose={() => setIsHelpDisplayed(false)}
        closeOnDocumentClick
        closeOnEscape
      >
        {HelpHelper}
      </Popup> */}

      {/* <div className="running"> אנחנו בהרצה, תהיו סבלניים :)</div> */}

      <div className="hamburger" onClick={humburgerClicked}></div>
    </div>
  );
};

export default Header;
